<template>
    <div class="right-block">
        <mobile-version @good-code="validateCode"/>
    </div>
</template>

<script>
import MobileVersion from './Responsive'
export default {
    components: {
        MobileVersion
    },

    methods: {
        validateCode() {
            this.$emit ('good-code')
        }
    }
}
</script>

<style>
.right-block {
    flex: 1;
}
/* Navigation */
.main-nav {
    display: flex;
    justify-content: flex-end;
    height: 10vh;
    border: 1px solid goldenrod;
}
 .main-nav ul {
     display: flex;
     justify-content: space-around;
     list-style: none;
     
 }
 ul:last-child {
     border-radius: 10px green 1px solid;
  }
</style>
